import { useParams } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";

const TITLES = {
  privacy: "Privacy Policy",
  terms: "Terms & Conditions",
  shipping: "Shipping Policy",
  returns: "Returns & Exchange Policy",
  custom_order: "Custom Order Policy",
  cancellation: "Cancellation Policy",
};

export default function Policy() {
  const { key } = useParams();
  const { settings } = useSettings();
  const policies = settings.policies || {};
  const title = TITLES[key] || "Policy";
  const body = policies[key] || "[This policy has not been added yet.]";

  return (
    <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
      <p className="label-accent text-kys-accent">Legal</p>
      <h1 className="mt-3 font-serif text-4xl tracking-tight text-kys-ink sm:text-5xl">{title}</h1>
      <div className="mt-8 whitespace-pre-line text-sm leading-relaxed text-kys-charcoal">{body}</div>
    </div>
  );
}
